import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Eleicao } from 'src/app/models/eleicao.model';
import { Resultado } from 'src/app/models/resultado.model';
import { ResultadosEleicao } from 'src/app/models/resultadosEleicao.model';
import { ResultadosService } from 'src/app/services/resultados.service';
import { ComprovanteService } from 'src/app/services/comprovante.service';
import { VotoService } from 'src/app/services/voto.service';
import { __param } from 'tslib';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { ComprovantePlanilhaDTO } from 'src/app/models/comprovantePlanilhaDTO.model';
import { typeWithParameters } from '@angular/compiler/src/render3/util';



@Component({
  selector: 'app-table-resultado-eleicao',
  templateUrl: './table-resultado-eleicao.component.html',
  styleUrls: ['./table-resultado-eleicao.component.css']
})
export class TableResultadoEleicaoComponent implements OnInit {

  public resultados: Resultado[] = [];
  public listaPorPlano:  Resultado[] = [];
  public resultadosEleicao: ResultadosEleicao;
  public token: any;
  public totalVotos: number;
  public listaPlanosFiltrada : string [] = [];
  public listaPlano : string [] =[];
  public comprovantesPlanilha : ComprovantePlanilhaDTO [] = [];
  public ehEleitor : boolean;
  
  @Input() eleicaoId: number;
  logo: any;
  offset: number;
  
  constructor(
    protected resultadosService: ResultadosService,
    protected votoService: VotoService,
    protected comprovanteService: ComprovanteService,
    public spinner: NgxSpinnerService,
    protected router: Router,
    public utils: Utils
    ) {}
    
  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    this.ehEleitor = sessionStorage.getItem("infoEleitor") != null;
    this.getResultados(this.eleicaoId, this.token);
    if (!this.ehEleitor){
      this.getComprovanteVotantes(this.eleicaoId,this.token);
    }
    // var logoRaw = sessionStorage.getItem("logoeleicao");
    // this.logo = logoRaw
  }

 async getResultados(idEleicao: number, token: any) {
    this.resultadosService.getAllByIdEleicao(idEleicao, token).then((resultados: ResultadosEleicao) => {
      console.log(resultados)
      this.resultadosEleicao = resultados;
      this.resultados = this.resultadosEleicao.resultados.sort(sortBy('cargoId', '-numVotos'));
      const resultadosSemBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome != 'Nulo' && par.candidatoNome != 'Branco' );
      const resultadosBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome == 'Nulo' || par.candidatoNome == 'Branco' );
      this.resultados = resultadosSemBrancosNulos.concat(resultadosBrancosNulos);
      this.criarListadePlanos(this.resultados);
      console.log(this.resultadosEleicao)
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  criarListadePlanos(lista:Resultado[]){
    lista.forEach(l => {
      this.listaPlano.push(l.plano);
      if(l.plano == '' && l.numVotos == 0){
        this.listaPlano.pop();
      }
    });
    this.listaPlanosFiltrada = this.listaPlano.filter(this.onlyUnique); // [GERAL, '', plano1, plano2, ...]
    console.log(this.listaPlanosFiltrada);
    this.spinner.hide();
  }
  somaTotalPorPlano(param:any){
    var sum = this.resultados.filter(p=> p.plano == param).reduce((sum, element) => { return sum + element.numVotos; }, 0);
     //console.log(sum);
    return sum;
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  exportParaExcel(){
    let dadosResultado = this.resultados
    this.utils.exportParaExcel(dadosResultado,this.resultadosEleicao.titulo,this.listaPlanosFiltrada)
  }

  getComprovanteVotantes(idEleicao: number, token: any) {
    this.comprovanteService.getComprovantesPorIdEleicao(idEleicao, token).then((res:any) => {
      this.comprovantesPlanilha = res;
      //console.log(res);
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  exportVotantesParaExcel(){
    this.utils.exportComprovantesParaExcel(this.comprovantesPlanilha,this.resultadosEleicao.titulo,this.listaPlanosFiltrada)
  }
  
}


